import { TopProductsResponse } from "@src/pages/Analytics/Sections/TopPositions/data/model/TopProductsResponse";
import { instance } from "./api";
import { OrderGraphDTO } from "@src/pages/Analytics/Sections/OrderGraph/data/model/OrderGraphDTO";
import { SalesDTO } from "@src/pages/Analytics/Sections/Sales/data/SalesDTO";

export interface FetchPopularPositionsProps {
  startDate: string;
  endDate: string;
  restaurantId: string;
  groupId: string;
  aggregator: string;
  sortBy?: string;
}

export interface FetchAnalyticsGraphProps {
  startDate: string;
  endDate: string;
  restaurantId: string;
  groupId: string;
}

export const analyticsApi = {
  async fetchPopularPositions(
    props: FetchPopularPositionsProps
  ): Promise<TopProductsResponse> {
    const { restaurantId, groupId, startDate, endDate, aggregator, sortBy } =
      props;

    const response = await instance.post<TopProductsResponse>(
      "v2/analytics/popular-products",
      {
        restaurant_id: restaurantId,
        restaurant_group_id: groupId,
        start_date: startDate,
        end_date: endDate,
        aggregator: aggregator,
        sort_by: sortBy,
      }
    );

    return response.data;
  },

  async fetchGraph(props: FetchAnalyticsGraphProps): Promise<OrderGraphDTO> {
    const { restaurantId, groupId, startDate, endDate } = props;

    const response = await instance.post<OrderGraphDTO>(
      "v2/analytics/by-date",
      {
        restaurant_id: restaurantId,
        restaurant_group_id: groupId,
        start_date: startDate,
        end_date: endDate,
      }
    );

    return response.data;
  },
  async fetchSales(
    props: FetchPopularPositionsProps
  ): Promise<SalesDTO | null | undefined> {
    const { restaurantId, groupId, startDate, endDate, aggregator } = props;

    const response = await instance.post<SalesDTO | null | undefined>(
      "v2/analytics/total-amount",
      {
        restaurant_id: restaurantId,
        restaurant_group_id: groupId,
        start_date: startDate,
        end_date: endDate,
        aggregator: aggregator,
      }
    );

    return response.data;
  },
};
